// /loginOTP/verify 
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import axios from "../../components/helpers/Axios";

// export const login=createAsyncThunk("user/login",async({values,navigate,setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//        const res=await axios.post("/login",values) 
//        setStateSnackbarContext(
//         true,
//         "logged in success",
//         "success"
//       )
//        navigate("/")
//       return res.data.user
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

//this one
// export const ActivateTrailLink=createAsyncThunk("link/activate",async({setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//       const res=await axios.get("/activate/link")
//       if(res.status===200){
//          return  setStateSnackbarContext(
//         true,
//         res.data.message,
//         "success"
//       )
//       }

//     } catch (error) {
//          return rejectWithValue(error.response.data.message)
//     }
// })
//this one track
// export const trackUpgradeClick=createAsyncThunk("track/upgrade",async(arg,{rejectWithValue})=>{
//     try {
//         const res=await axios.get("/track/upgrade")
//         return res.data.status
//     } catch (error) {
//           return rejectWithValue(error.response.data.message)
//     }
// })

// export const trackModalClick=createAsyncThunk("track/modal",async(arg,{rejectWithValue})=>{
//     try {
//           const res=await axios.get("/track/modal")
//             return res.data.status
//     } catch (error) {
//          return rejectWithValue(error.response.data.message)
//     }
// })

  export const trackPreviewClick=createAsyncThunk("track/preview",async(arg,{rejectWithValue})=>{
    try {
         const res=await axios.get("/track/preview")

          return res.data.user
    } catch (error) {
         return rejectWithValue(error.response.data.message)
    }
  })

  export const trackShareClick = createAsyncThunk("track/share",async (arg, { rejectWithValue }) => {
    try {
      const res = await axios.get("/track/share");
      return res.data.user;
    } catch (error) {
     return rejectWithValue(error.response.data.message)
    }
  }
);

// export const sendOTP=createAsyncThunk("user/otp",async({values,setStateSnackbarContext,setStep,navigate},{rejectWithValue})=>{
//     try {
//         const res=await axios.post("/demouser/create",values)
//         if(res.data.message=="Number already used.Please log in"){
//           return  setStateSnackbarContext(
//         true,
//         "Number already Registered.Please log in",
//         "warning"
//       )
//         } 

//          if(res.data.message=="verified but not signup"){
//         setStateSnackbarContext(
//         true,
//         "Please complete your Signup",
//         "warning"
//       )
//        navigate(`/signup/${res.data && res.data.data.userCode}?demo=true`)
//          return res.data.data
//         } 
        
//         setStateSnackbarContext(
//         true,
//         "OTP Send Successfully",
//         "success"
//       )
//       setStep("verify")
//          return res.data.whatsappno
//     } catch (error) {
//          return rejectWithValue(error.response.data.message)
//     }
// })

// export const verifyOTP=createAsyncThunk("otp/verify",async({whatsappno, otp, consentValues,utm,setStateSnackbarContext,navigate},{rejectWithValue})=>{
//     try {
//         const res=await axios.post("/demouser/verify",{ whatsappno, otp,consentValues,utm })
//          setStateSnackbarContext(
//         true,
//         "OTP Verified Sucessfully",
//         "success"
//       )
//     //   console.log(res.data.data)
//        navigate(`/signup/${res.data && res.data.data.userCode}?demo=true`)
//          return res.data.data
//     } catch (error) {
//          return rejectWithValue(error.response.data.message)
//     }
// })

// export const demousersingup=createAsyncThunk("demouser/signup",async({values,navigate,setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//         const res=await axios.post("/demouser/signup",values)
//         setStateSnackbarContext(
//             true,
//             "signed in success",
//             "success"
//           )
//            navigate("/demo-wedding-invitation")
//           return res.data.user
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

// export const singup=createAsyncThunk("user/signup",async({values,navigate,setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//         const res=await axios.post("/signup",values)
//         setStateSnackbarContext(
//             true,
//             "Sign-up complete!Just one step left to finish setting up.",
//             "success"
//           )
//            navigate(`/signup/${res.data.user.userCode}/date`)
//           return res.data.user
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

export const singupdate=createAsyncThunk("signup/date",async({values,navigate,setStateSnackbarContext},{rejectWithValue})=>{
    try {
        const res=await axios.post("/datesignup",values)
        setStateSnackbarContext(
            true,
            "Welcome To Aamantran",
            "success"
          )
           navigate("/")
          return res.data.user
    } catch (error) {
        return rejectWithValue(error.response.data.message)
    }
})

export const loadUser=createAsyncThunk("user/load",async(arg,{rejectWithValue})=>{
try {
    const res=await axios.get("/me")
    return res.data.user  
} catch (error) {
    return rejectWithValue(error.response.data.message)
}
})

export const isSignedIn=createAsyncThunk("user/isSignedIn",async({id,setNotFound},{rejectWithValue})=>{
    try {
     const res=await axios.get(`/issignedin/${id}`)  
     if(res.data.user.hasSignedUp){
       setNotFound(true)
      }
    //     if(res.data.user.stepOneCompleted){
    //    setNotFound(true)
    //   }
    } catch (error) {
        if(error.response.data.message==="user not found"){
            setNotFound(true)
           }
        return rejectWithValue(error.response.data.message)
    }
})
//remove this also
// export const changeLive=createAsyncThunk("live/status",async({newValue,setStateSnackbarContext},{rejectWithValue})=>{
// try {
//     const res=await axios.post("/status/update",{newValue})
//     setStateSnackbarContext(
//             true,
//             res.data.message,
//             "success"
//           )
//         //   setLive(res.data.user.isLive)
//           return res.data.user;
    
// } catch (error) {
//  return rejectWithValue(error.response.data.message)    
// }
// })

// export const forgotPassword=createAsyncThunk("password/forgot",async({values,setStateSnackbarContext,switchtologin},{rejectWithValue})=>{
//     try {
//          await axios.post("/password/forgot",values)
//          setStateSnackbarContext(
//             true,
//             "check your email inbox or spam folder",
//             "info"
//          )
//          switchtologin()

//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

// export const newPassword=createAsyncThunk("password/reset",async({token,values,setStateSnackbarContext,navigate},{rejectWithValue})=>{
//     try {
//          await axios.put(`/password/reset/${token}`,values)
//          setStateSnackbarContext(
//             true,
//             "password update success",
//             "success"
//          )
//          setTimeout(() => {
//             navigate("/login")
//          }, 2000);
      
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

// export const updateEmail=createAsyncThunk("email/update",async({values,setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//           await axios.post("/email/update",values)
//           setStateSnackbarContext(
//             true,
//             "check your email inbox or spam folder",
//             "info"
//          )
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

// export const enableGrouping=createAsyncThunk("grouping/update",async({value,setStateSnackbarContext},{rejectWithValue})=>{
//     try {
//           const res=await axios.post("/group/update",{value})
//           setStateSnackbarContext(
//         true,
//         res.data.message,
//         "success"
//       )
//       return res.data.user
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })



// export const changePass=createAsyncThunk("password/change",async({values,setStateSnackbarContext,setValues},{rejectWithValue})=>{
//     try {
//             await axios.put("/password/update",values)
//             setStateSnackbarContext(
//             true,
//             "password update success",
//             "success"
//          )
//          setValues({
//             oldPassword: "",
//             password: "",
//             confirmPassword: ""
//           });
//     } catch (error) {
//         return rejectWithValue(error.response.data.message)
//     }
// })

export const logout=createAsyncThunk("user/logout",async({navigate,setStateSnackbarContext,end},{rejectWithValue})=>{
    try {
        await axios.get("/logout")
        if(end){
            setStateSnackbarContext(
                true,
                "Invite ended success please login again",
                "success"
            )
        }else{
        setStateSnackbarContext(
            true,
            "logged out success",
            "success"
        )
        }
        navigate("/login")
    } catch (error) {
        return rejectWithValue(error.response.data.message)
    }
    })

    // export const endInvite=createAsyncThunk("invite/end",async(arg,{rejectWithValue})=>{
    //     try {
    //         await axios.get("/invite/end")
    //     } catch (error) {

    //         return rejectWithValue(error.response.data.message)
    //     }
    //     })
    

     export const getAuthProp=createAsyncThunk("auth/prop",async({id,setNotFound,setDemoExpired,setInviteExpired},{rejectWithValue})=>{
     
        try {
            const res=await axios.get(`/hasended/${id}`)
    

             if (res.data.userData?.demoVersion && res.data.userData?.demoExpiryTime) {
        const now = Date.now();
        const demoExpiry = new Date(res.data.userData.demoExpiryTime).getTime();
              setDemoExpired(now >= demoExpiry)
      }
            
            if(res.data.userData.inviteTimeExpired){
                setInviteExpired(true)
            }

      return res.data.userData;

            // if(res.data.user.hasEnded===true){
            //     setHasEnded(true)
            // }
            // if(res.data.user.demoVersion===true){
            //     setdemoVersion(true)
            // }
            //  if(res.data.user.inviteTimeExpired===true){
            //     setInviteExpired(true)
            // }

            // if(res.data.user.demoExpiryTime){
            //     const now = new Date().getTime();
            //  const expiryTime = new Date(res.data.user.demoExpiryTime).getTime();
            //  if(now>expiryTime){
            //     setDemoExpired(true)
            //  }
            // }

//             const now = new Date().getTime();

// let isExpired = false;

// Demo expiry (4 days)
// if (res.data.user.demoExpiryTime) {
//   const demoExpiry = new Date(res.data.user.demoExpiryTime).getTime();
//   if (now > demoExpiry) {
//     isExpired = true;
//   }
// }

// Share expiry (48h)
// if (res.data.user.shareExpiryTime) {
//   const shareExpiry = new Date(res.data.user.shareExpiryTime).getTime();
//   if (now > shareExpiry) {
//     isExpired = true;
//   }
// }

// Final decision
// if (isExpired) {
//   setDemoExpired(true);
// }

            // if(res.data.user.isLive===false){
            //   setNotLive(true)
            // }
           
    //          if (res.data.user.stepOneCompleted === false) {
    //             setRedirectToStep("step1");
    //   } else if (res.data.user.stepTwoCompleted === false) {
    //              setRedirectToStep("step2");
    //   }

            // setLoading(false)
        } catch (error) {
            if(error.response.data.message==="invalid user"){
                setNotFound(true)
            }
            return rejectWithValue(error.response.data.message)
        }
     }) 

     export const googleTrialLogin=createAsyncThunk("user/googleTrialLogin",async({credential,setStateSnackbarContext,navigate,themeId,utm,fbp,fbc},{rejectWithValue})=>{
        try {
              const res = await axios.post("/demouser/google", {credential,themeId,utm,fbp,fbc});
                      setStateSnackbarContext(
            true,
            "signed in success",
            "success"
          )
          if(res.data.message==="Logged in successfully"){
              navigate("/")
          } else{
              navigate("/details")
          }
            return res.data.user
            } catch (error) {
                if(error.response.data.message==="Your Trial Has Expired"){
                    navigate("/trial/expired")
                }
            return rejectWithValue(error.response.data.message)
            
        }
     })

     export const LoginbyGoogle=createAsyncThunk("login/google",async({credential,setStateSnackbarContext,navigate},{rejectWithValue})=>{
        try {
             const res=await axios.post("/login/google",{credential}) 
             setStateSnackbarContext(
            true,
            "Logged in success",
            "success"
          )
           navigate("/")
            return res.data.user
        } catch (error) {
              if(error.response.data.message==="Your Trial Has Expired"){
                    navigate("/trial/expired")
                }
              return rejectWithValue(error.response.data.message)
        }
     })

     export const sendLoginOTP=createAsyncThunk("login/otp",async({email,setStateSnackbarContext,onContinue,isResend,setSeconds,setOtp,navigate},{rejectWithValue})=>{
        try {
            const res=await axios.post("/userlogin/otp",{email})
             setStateSnackbarContext(
            true,
            "OTP sent Sucessfully! check your email inbox or spam folder",
            "success"
         )

           // =========================================
      // INITIAL OTP
      // =========================================

          if (!isResend) {
        onContinue();
      }

      // =========================================
      // RESEND OTP
      // =========================================

      if (isResend) {

        setSeconds(57);

        setOtp([
          "",
          "",
          "",
          "",
          "",
          "",
        ]);
      }

            return res.data.email


        } catch (error) { 
              if(error.response.data.message==="Your Trial Has Expired"){
                    navigate("/trial/expired")
                }
             return rejectWithValue(error.response.data.message)
        }
     })

       export const adminLogin = createAsyncThunk(
  "admin/login",
  async (
    {
      email,
      setStateSnackbarContext,
      onContinue,
      navigate
    },
    { rejectWithValue }
  ) => {
    try {

      const res = await axios.post("/admin/login", {
        email
      });

      setStateSnackbarContext(
        true,
        "Admin access verified",
        "success"
      );

      // Open the EXISTING OTP screen
      onContinue("admin");

      return res.data.email;

    } catch (error) {

      if (error.response?.data?.message === "Your Trial Has Expired") {
        navigate("/trial/expired");
      }

      return rejectWithValue(
        error.response?.data?.message ||
        "Unable to continue with admin access"
      );
    }
  }
);

export const verifyAdminLoginOTP = createAsyncThunk(
  "adminLoginOTP/verify",
  async (
    { email, otp, setStateSnackbarContext, navigate },
    { rejectWithValue }
  ) => {
    try {
      const res = await axios.post("/admin/login/verify", {
        email,
        otp
      });

      setStateSnackbarContext(
        true,
        "Logged in successfully",
        "success"
      );

      navigate("/");

      return res.data.user;

    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        "Unable to verify admin access"
      );
    }
  }
);


      export const sendEmailOTP=createAsyncThunk("email/sendOTP",async({email,name,setStateSnackbarContext,onContinue,isResend,setSeconds,setOtp,navigate,theme,utm,fbp,fbc},{rejectWithValue})=>{
        try {
            const res=await axios.post('/trialuser/create',{email,name,theme,utm,fbp,fbc})
           setStateSnackbarContext(
            true,
            "OTP sent Sucessfully! check your email inbox or spam folder",
            "success"
         )
         // =========================================
      // INITIAL OTP
      // =========================================

      if (!isResend) {
        onContinue();
      }

// =========================================
      // RESEND OTP
      // =========================================

      if (isResend) {

        setSeconds(57);

        setOtp([
          "",
          "",
          "",
          "",
          "",
          "",
        ]);
      }

            return res.data.email
            
        
        } catch (error) {
             if(error.response.data.message==="Your Trial Has Expired"){
                    navigate("/trial/expired")
                }

            if(error.response.data.message==="Account already exists. Please log in"){
                    navigate("/login")
                }
            return rejectWithValue(error.response.data.message)
            
        }
      }

      )

      export const verifyEmailOTP=createAsyncThunk("emailotp/verify",async({email,otp,setStateSnackbarContext,navigate},{rejectWithValue})=>{
               try {
                   const res=await axios.post("/trialuser/verify",{email,otp})
                   setStateSnackbarContext(
            true,
            "signed in success",
            "success"
          )
            navigate("/details")
            return res.data.user
               } catch (error) {
                if(error.response.data.message==="Your free trial has already been used"){
                    navigate("/display/notfound")
                }
                return rejectWithValue(error.response.data.message)
               }
      })

      export const verifyLoginOTP=createAsyncThunk("loginOTP/verify",async({email,otp,setStateSnackbarContext,navigate},{rejectWithValue})=>{
          try {
             const res=await axios.post("/loginOTP/verify",{email,otp})
               setStateSnackbarContext(
            true,
            "logged in success",
            "success"
          )
           navigate("/")
            return res.data.user

            } catch (error) {
                             return rejectWithValue(error.response.data.message)
          }
      })

      export const getuser=createAsyncThunk("user/find",async({id,setNotFound,setLoading,setHasEnded},{rejectWithValue})=>{
        try {
            const res=await axios.get(`/user/${id}`)
              if(res.data.user.hasEnded===true){
              setHasEnded(true)
            }

            setLoading(false)
        
            return res.data.user
        } catch (error) {
            if(error.response.data.message==="user not found"){
                setNotFound(true)
            }
            return rejectWithValue(error.response.data.message)
        }
     }) 

   



const authSlice=createSlice({
    name:"user",
    initialState:{
      user:null,
      loading:false,
      isAuthenticated:false,
      error:""
    },
    reducers:{
     clearError:(state)=>{
        state.error=null;
     },
     clearUser:(state)=>{
        state.isAuthenticated=false;
     }
    },
    extraReducers:(builder)=>{
        builder
        // .addCase(login.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(login.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload;
        //     state.isAuthenticated=true;
        // })
        // .addCase(login.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        // .addCase(singup.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(singup.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload;
        //     state.isAuthenticated=true;
        // })
        // .addCase(singup.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

         .addCase(singupdate.pending,(state)=>{
            state.loading=true
        })
        .addCase(singupdate.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
            state.isAuthenticated=true;
        })
        .addCase(singupdate.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        //  .addCase(demousersingup.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(demousersingup.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload;
        //     state.isAuthenticated=true;
        // })
        // .addCase(demousersingup.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })
        .addCase(loadUser.pending,(state)=>{
            state.loading=true
        })
        .addCase(loadUser.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
             state.isAuthenticated=true;
        })
        .addCase(loadUser.rejected,(state,action)=>{
            state.loading=false;
            state.isAuthenticated=false;
            state.error=action.payload
        })

        // .addCase(forgotPassword.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(forgotPassword.fulfilled,(state,action)=>{
        //     state.loading=false;
        // })
        // .addCase(forgotPassword.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        
        // .addCase(newPassword.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(newPassword.fulfilled,(state,action)=>{
        //     state.loading=false;
        // })
        // .addCase(newPassword.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })


        // .addCase(updateEmail.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(updateEmail.fulfilled,(state,action)=>{
        //     state.loading=false;
        // })
        // .addCase(updateEmail.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        // .addCase(changePass.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(changePass.fulfilled,(state,action)=>{
        //     state.loading=false;
        // })
        // .addCase(changePass.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        .addCase(logout.pending,(state)=>{
            state.loading=true
        })
        .addCase(logout.fulfilled,(state,action)=>{
            state.loading=false;
            state.isAuthenticated=false
        })
        .addCase(logout.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        // .addCase(endInvite.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(endInvite.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.isAuthenticated=false
        // })
        // .addCase(endInvite.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        //   .addCase(sendOTP.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(sendOTP.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload
        // })
        // .addCase(sendOTP.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

        //   .addCase(verifyOTP.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(verifyOTP.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload
        // })
        // .addCase(verifyOTP.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

         .addCase(trackPreviewClick.pending,(state)=>{
            state.loading=true
        })
        .addCase(trackPreviewClick.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload
        })
        .addCase(trackPreviewClick.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

         .addCase(trackShareClick.pending,(state)=>{
            state.loading=true
        })
        .addCase(trackShareClick.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload
        })
        .addCase(trackShareClick.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
     
        //   .addCase(changeLive.pending,(state)=>{
        //     state.loading=true
        // })
        // .addCase(changeLive.fulfilled,(state,action)=>{
        //     state.loading=false;
        //     state.user=action.payload;
        // })
        // .addCase(changeLive.rejected,(state,action)=>{
        //     state.loading=false;
        //     state.error=action.payload
        // })

         .addCase(getuser.pending,(state)=>{
            state.loading=true
        })
        .addCase(getuser.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
        })
        .addCase(getuser.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

          .addCase(googleTrialLogin.pending,(state)=>{
            state.loading=true
        })
        .addCase(googleTrialLogin.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
            state.isAuthenticated=true;
        })
        .addCase(googleTrialLogin.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

          .addCase(LoginbyGoogle.pending,(state)=>{
            state.loading=true
        })
        .addCase(LoginbyGoogle.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
            state.isAuthenticated=true;
        })
        .addCase(LoginbyGoogle.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

            .addCase(sendEmailOTP.pending,(state)=>{
            state.loading=true
        })
        .addCase(sendEmailOTP.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload
        })
        .addCase(sendEmailOTP.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

           .addCase(sendLoginOTP.pending,(state)=>{
            state.loading=true
        })
        .addCase(sendLoginOTP.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload
        })
        .addCase(sendLoginOTP.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

           .addCase(verifyLoginOTP.pending,(state)=>{
            state.loading=true
        })
        .addCase(verifyLoginOTP.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
            state.isAuthenticated=true;
        })
        .addCase(verifyLoginOTP.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

         
                .addCase(verifyEmailOTP.pending,(state)=>{
            state.loading=true
        })
        .addCase(verifyEmailOTP.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
            state.isAuthenticated=true;
        })
        .addCase(verifyEmailOTP.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

          .addCase(getAuthProp.pending,(state)=>{
            state.loading=true
        })
        .addCase(getAuthProp.fulfilled,(state,action)=>{
            state.loading=false;
            state.user=action.payload;
        })
        .addCase(getAuthProp.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

            .addCase(adminLogin.pending, (state) => {
  state.loading = true;
})

.addCase(adminLogin.fulfilled, (state, action) => {
  state.loading = false;
  state.user = action.payload;
})

.addCase(adminLogin.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

.addCase(verifyAdminLoginOTP.pending, (state) => {
  state.loading = true;
})

.addCase(verifyAdminLoginOTP.fulfilled, (state, action) => {
  state.loading = false;
  state.user = action.payload;
  state.isAuthenticated = true;
})

.addCase(verifyAdminLoginOTP.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

        
    }
})

export const {clearError,clearUser}=authSlice.actions

export default authSlice.reducer;